import {
  GET_SHIPVIA_OPTIONS_FAIL,
  GET_SHIPVIA_OPTIONS_REQUEST,
  GET_SHIPVIA_OPTIONS_SUCCESS,
  GET_WAREHOUSE_OPTIONS_FAIL,
  GET_WAREHOUSE_OPTIONS_REQUEST,
  GET_WAREHOUSE_OPTIONS_SUCCESS,
  SHIPMENT_COUNT_FAIL,
  SHIPMENT_COUNT_REQUEST,
  SHIPMENT_COUNT_SUCCESS,
  SHIPMENT_CREATE_FAIL,
  SHIPMENT_CREATE_REQUEST,
  SHIPMENT_CREATE_RESET,
  SHIPMENT_CREATE_SUCCESS,
  SHIPMENT_DELETE_FAIL,
  SHIPMENT_DELETE_REQUEST,
  SHIPMENT_DELETE_SUCCESS,
  SHIPMENT_DETAILS_FAIL,
  SHIPMENT_DETAILS_REQUEST,
  SHIPMENT_DETAILS_SUCCESS,
  SHIPMENT_GRID_FAIL,
  SHIPMENT_GRID_REQUEST,
  SHIPMENT_GRID_SUCCESS,
  SHIPMENT_INITIALIZE_FAIL,
  SHIPMENT_INITIALIZE_REQUEST,
  SHIPMENT_INITIALIZE_SUCCESS,
  SHIPMENT_LIST_FAIL,
  SHIPMENT_LIST_REQUEST,
  SHIPMENT_LIST_SUCCESS,
  SHIPMENT_SUMMARY_FAIL,
  SHIPMENT_SUMMARY_REQUEST,
  SHIPMENT_SUMMARY_SUCCESS,
  SHIPMENT_UPDATE_FAIL,
  SHIPMENT_UPDATE_REQUEST,
  SHIPMENT_UPDATE_RESET,
  SHIPMENT_UPDATE_SUCCESS
} from '@/constants/shipmentConstants'

// --- Multiple Shipments Storage (Lists, Grids, Summaries) ---
export const shipmentListReducer = (state = { shipments: [], grid: [], summary: {}, count: 0 }, action) => {
  switch (action.type) {
    // List
    case SHIPMENT_LIST_REQUEST:
      return { ...state, loading: true }
    case SHIPMENT_LIST_SUCCESS:
      return { ...state, loading: false, shipments: action.payload }
    case SHIPMENT_LIST_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Grid
    case SHIPMENT_GRID_REQUEST:
      return { ...state, loadingGrid: true }
    case SHIPMENT_GRID_SUCCESS:
      return { ...state, loadingGrid: false, grid: action.payload }
    case SHIPMENT_GRID_FAIL:
      return { ...state, loadingGrid: false, errorGrid: action.payload }

    // Summary
    case SHIPMENT_SUMMARY_REQUEST:
      return { ...state, loadingSummary: true }
    case SHIPMENT_SUMMARY_SUCCESS:
      return { ...state, loadingSummary: false, summary: action.payload }
    case SHIPMENT_SUMMARY_FAIL:
      return { ...state, loadingSummary: false, errorSummary: action.payload }

    // Count
    case SHIPMENT_COUNT_REQUEST:
      return { ...state, loadingCount: true }
    case SHIPMENT_COUNT_SUCCESS:
      return { ...state, loadingCount: false, count: action.payload.count }
    case SHIPMENT_COUNT_FAIL:
      return { ...state, loadingCount: false, errorCount: action.payload }

    // Initialization
    case SHIPMENT_INITIALIZE_REQUEST:
      return { ...state, loadingInit: true }
    case SHIPMENT_INITIALIZE_SUCCESS:
      return { ...state, loadingInit: false, successInit: true }
    case SHIPMENT_INITIALIZE_FAIL:
      return { ...state, loadingInit: false, errorInit: action.payload }

    default:
      return state
  }
}

// --- Single Shipment Storage (Details, CRUD Status) ---
export const shipmentDetailsReducer = (state = { shipment: {} }, action) => {
  switch (action.type) {
    // Get Details
    case SHIPMENT_DETAILS_REQUEST:
      return { ...state, loading: true }
    case SHIPMENT_DETAILS_SUCCESS:
      return { ...state, loading: false, shipment: action.payload }
    case SHIPMENT_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Create
    case SHIPMENT_CREATE_REQUEST:
      return { ...state, loadingCreate: true }
    case SHIPMENT_CREATE_SUCCESS:
      return { ...state, loadingCreate: false, successCreate: true, shipment: action.payload }
    case SHIPMENT_CREATE_FAIL:
      return { ...state, loadingCreate: false, errorCreate: action.payload }
    case SHIPMENT_CREATE_RESET:
      return { ...state, successCreate: false, errorCreate: null }

    // Update
    case SHIPMENT_UPDATE_REQUEST:
      return { ...state, loadingUpdate: true }
    case SHIPMENT_UPDATE_SUCCESS:
      return { ...state, loadingUpdate: false, successUpdate: true, shipment: action.payload }
    case SHIPMENT_UPDATE_FAIL:
      return { ...state, loadingUpdate: false, errorUpdate: action.payload }
    case SHIPMENT_UPDATE_RESET:
      return { ...state, successUpdate: false, errorUpdate: null }

    // Delete
    case SHIPMENT_DELETE_REQUEST:
      return { ...state, loadingDelete: true }
    case SHIPMENT_DELETE_SUCCESS:
      return { ...state, loadingDelete: false, successDelete: true }
    case SHIPMENT_DELETE_FAIL:
      return { ...state, loadingDelete: false, errorDelete: action.payload }

    default:
      return state
  }
}

export const shipmentResourcesReducer = (state = { warehouseList: [], shipViaList: [] }, action) => {
  switch (action.type) {
    // --- Warehouse ---
    case GET_WAREHOUSE_OPTIONS_REQUEST:
      return { ...state, loadingWarehouses: true }
    case GET_WAREHOUSE_OPTIONS_SUCCESS:
      return {
        ...state,
        loadingWarehouses: false,
        warehouseList: action.payload
      }
    case GET_WAREHOUSE_OPTIONS_FAIL:
      return {
        ...state,
        loadingWarehouses: false,
        errorWarehouses: action.payload
      }

    // --- Ship Via ---
    case GET_SHIPVIA_OPTIONS_REQUEST:
      return { ...state, loadingShipVias: true }
    case GET_SHIPVIA_OPTIONS_SUCCESS:
      return {
        ...state,
        loadingShipVias: false,
        shipViaList: action.payload
      }
    case GET_SHIPVIA_OPTIONS_FAIL:
      return {
        ...state,
        loadingShipVias: false,
        errorShipVias: action.payload
      }

    default:
      return state
  }
}
